// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"triggers_scrollbar__OD5tp"};